import React, { Component, ReactNode } from 'react'

type ContentAsideLayout = 'half' | 'oneThird'
type ContentAsideLayouts = Record<ContentAsideLayout, string>

interface ContentAsideProps {
  layout: ContentAsideLayout
  children: ReactNode
}

export default class ContentAside extends Component<ContentAsideProps> {
  layouts: ContentAsideLayouts = {
    half: 'w-full lg:w-1/2',
    oneThird: 'w-full lg:w-1/3'
  }

  get className () {
    return this.layouts[this.props.layout]
  }

  render () {
    return (
      <div className={this.className}>
        {this.props.children}
      </div>
    )
  }
}
